<template>
  <div id="app" class="flex flex-col h-full">
    <main class="shrink-0">
      <app-header></app-header>
      <transition
        name="fade"
        mode="out-in"
      >
      <router-view></router-view>
      </transition>
    </main>
    <app-footer></app-footer>
    <version-check></version-check>
    <app-toast></app-toast>
  </div>
</template>

<script>
import Header from './components/Layout/Header.vue'
import Footer from './components/Layout/Footer.vue'
import VersionCheck from './components/UIComponents/VersionCheck.vue'
import AppToast from './components/UIComponents/Toast.vue'

export default {
  name: 'app',

  components: {
    'app-header': Header,
    'app-footer': Footer,
    'version-check': VersionCheck,
    'app-toast': AppToast
  }
}
</script>
